import { Head } from '@inertiajs/react'
import { PageHeader, PageContent } from '@/components/PageHeader'
import { Card, CardContent } from '@/components/ui/card'
import { DatabaseIcon, DownloadIcon, CalendarIcon } from 'lucide-react'

interface Props {
  backups: string[]
}

function parseBackupDate(filename: string): string {
  const match = filename.match(/(\d{4}-\d{2}-\d{2})/)
  if (match) {
    return new Date(match[1]).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }
  return filename
}

export default function Index({ backups }: Props) {
  return (
    <>
      <Head title="Backups" />
      <PageHeader
        title="Database Backups"
        description="Download previous database snapshots"
      />

      <PageContent>
        <Card>
          <CardContent className="p-0">
            {backups.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="rounded-full bg-muted p-3.5">
                  <DatabaseIcon className="h-6 w-6 text-muted-foreground" />
                </div>
                <h3 className="mt-3 text-[15px] font-medium text-foreground">No backups found</h3>
                <p className="mt-1 text-[13px] text-muted-foreground">
                  Database backups will appear here once created.
                </p>
              </div>
            ) : (
              <div className="divide-y divide-border">
                {backups.map((backup) => (
                  <a
                    key={backup}
                    href={`/backups/${backup.replace('.sqlite3', '')}`}
                    className="flex items-center justify-between px-5 py-3.5 transition-colors hover:bg-accent/50 group"
                  >
                    <div className="flex items-center gap-3">
                      <div className="rounded-lg bg-primary/8 p-2">
                        <DatabaseIcon className="h-4 w-4 text-primary" />
                      </div>
                      <div>
                        <p className="text-[13px] font-medium text-foreground group-hover:text-primary transition-colors">
                          {backup}
                        </p>
                        <div className="flex items-center gap-1 mt-0.5">
                          <CalendarIcon className="h-3 w-3 text-muted-foreground" />
                          <p className="text-[11px] text-muted-foreground">
                            {parseBackupDate(backup)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <DownloadIcon className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
                  </a>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </PageContent>
    </>
  )
}
